export default {
    data() {
        return {
            shouldShowPassword: false,
        }
    },

    computed: {
        passwordInputFieldType() {
            return this.shouldShowPassword ? 'text' : 'password'
        },
    },

    methods: {
        showPassword(event) {
            this.shouldShowPassword = event.isToggleOn
        },
    },
}
